import React, { Component, useRef, useState } from 'react';
import './App.css';
import { OutTable, ExcelRenderer } from 'react-excel-renderer';
import { Jumbotron, Col, Input, InputGroup, InputGroupAddon, FormGroup, Label, Fade, FormFeedback, Container } from 'reactstrap';
// import { useReactToPrint, ReactToPrint } from 'react-to-print';
import ReactToPrint from 'react-to-print';
import jsPDF from 'jspdf';

import $ from "jquery";
import Qs from "qs";
import PF from "./_Services/publicFunction";
import { indigo, teal, deepPurple, deepOrange, grey, green, brown, blueGrey } from '@material-ui/core/colors';
import { createTheme, withStyles, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { Button, Paper, TextField, Card, List, ListItem } from '@material-ui/core';
import Questionaire80th from './Questionaire/80th';

// import { ComponentToPrint } from './ComponentToPrint';

// const Example = () => {
//     const componentRef = useRef();
//     const handlePrint = useReactToPrint({
//         content: () => componentRef.current,
//     });
//     // const handlePrint = () => {
//     //     $('#xlsx').printThis();
//     // }
//     return (
//         <div>
//             <Questionaire80th componentRef={componentRef} />
//             <button onClick={handlePrint}>Print this out!</button>
//         </div>
//     );
// };

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            dataLoaded: false,
            isFormInvalid: false,
            rows: null,
            cols: null
        }
        this.fileHandler = this.fileHandler.bind(this);
        this.toggle = this.toggle.bind(this);
        this.openFileBrowser = this.openFileBrowser.bind(this);
        this.renderFile = this.renderFile.bind(this);
        this.openNewPage = this.openNewPage.bind(this);
        this.fileInput = React.createRef();
    }

    renderFile = (fileObj) => {
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                console.log(err);
            }
            else {
                this.setState({
                    dataLoaded: true,
                    cols: resp.cols,
                    rows: resp.rows
                });
            }
        });
    }

    fileHandler = (event) => {
        if (event.target.files.length) {
            let fileObj = event.target.files[0];
            let fileName = fileObj.name;


            //check for file extension and pass only if it is .xlsx and display error message otherwise
            if (fileName.slice(fileName.lastIndexOf('.') + 1) === "xlsx") {
                this.setState({
                    uploadedFileName: fileName,
                    isFormInvalid: false
                });
                this.renderFile(fileObj)
            }
            else {
                this.setState({
                    isFormInvalid: true,
                    uploadedFileName: ""
                })
            }
        }
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    openFileBrowser = () => {
        this.fileInput.current.click();
    }

    openNewPage = (chosenItem) => {
        const url = chosenItem === "github" ? "https://github.com/ashishd751/react-excel-renderer" : "https://medium.com/@ashishd751/render-and-display-excel-sheets-on-webpage-using-react-js-af785a5db6a7";
        window.open(url, '_blank');
    }

    render() {
        return (
            <div>
                <Container>
                    <form>
                        <FormGroup row>
                            <Label for="exampleFile" xs={6} sm={4} lg={2} size="lg">Upload</Label>
                            <Col xs={4} sm={8} lg={10}>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <Button color="info" style={{ color: "white", zIndex: 0 }} onClick={this.openFileBrowser.bind(this)}><i className="cui-file"></i> Browse&hellip;</Button>
                                        <input type="file" hidden onChange={this.fileHandler.bind(this)} ref={this.fileInput} onClick={(event) => { event.target.value = null }} style={{ "padding": "10px" }} />
                                    </InputGroupAddon>
                                    <Input type="text" className="form-control" value={this.state.uploadedFileName} readOnly invalid={this.state.isFormInvalid} />
                                    <FormFeedback>
                                        <Fade in={this.state.isFormInvalid} tag="h6" style={{ fontStyle: "italic" }}>
                                            Please select a .xlsx file only !
                                        </Fade>
                                    </FormFeedback>
                                </InputGroup>
                            </Col>
                        </FormGroup>
                        {/* <button onClick={{}}>Print</button> */}
                    </form>

                    {this.state.dataLoaded &&
                        <div>
                            <Card body outline color="secondary" className="restrict-card">

                                <OutTable ref={this.props.componentRef} data={this.state.rows} columns={this.state.cols} tableClassName="ExcelTable2007" tableHeaderRowClass="heading" />

                            </Card>
                        </div>}
                </Container>
            </div>
        );
    }
}


// const Example = () => {
//     const componentRef = useRef();

//     return (
//         <div>
//             <ReactToPrint
//                 trigger={() => <button>Print this out!</button>}
//                 content={() => componentRef.current}
//             />
//             <App ref={componentRef} />
//         </div>
//     );
// };
//連動
const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
}));

const theme = createTheme({
    palette: {
        primary: green,
    },
});
class ExportPdfComponent extends React.Component {

    render() {
        return (
            <div>

                <h1>Export HTMl Table in PDF File</h1>

                <Questionaire80th ref={(response) => (this.componentRef = response)} />

                <ReactToPrint
                    content={() => this.componentRef}
                    trigger={() => <button className="btn btn-primary">Print to PDF!</button>}
                />
            </div>
        );
    }
}
const LINE = props => {
    const classes = useStyles();
    const [user, SetUser] = useState({
        token: "",
        messages: ""
    })
    const handleSend = e => {

        // let data = {
        //     'grant_type': 'authorization_code',
        //     'code': "1GoJVEp1ePgeRevkS72zrQ",
        //     'redirect_uri': "https://localhost:44311/home/test",
        //     'client_id': "cD6fcMXzLV8GL76u2hL5xB",
        //     'client_secret': "XqDonAsQMnFDWXnRvez7JJSoewe2AC1ytWTKF1b6l17"
        // }
        console.log(user)

        PF.instance({
            method: "post",
            url: PF.url + "/HOME/Contact",
            data: Qs.stringify(user),
        })
            .then(function (response) {
                // alert("完成")
                console.log(response.data)
            })
    }
    const handleChange = e => {
        const { name, value } = e.target;
        SetUser(prev => ({
            ...prev,
            [name]: value
        }))
    }
    return (
        <>
            <ThemeProvider theme={theme}>
                <Button color="primary" variant="contained" className={classes.margin}><a href="https://notify-bot.line.me/oauth/authorize?response_type=code&scope=notify&response_mode=form_post&client_id=cD6fcMXzLV8GL76u2hL5xB&redirect_uri=https://www.mornjoy.com.tw/exportexcel/home/test&state=azsx9999" style={{ textDecoration: "none", color: "white" }}>LINE連動</a></Button>
            </ThemeProvider>
            <Paper variant="outlined" elevation={3}>
                <List>
                    <TextField key={1} onChange={handleChange} name="token" label="Token" autoComplete="off" fullWidth />
                    <TextField key={2} onChange={handleChange} name="messages" label="Message" autoComplete="off" fullWidth />
                    <Button color="primary" variant="contained" onClick={handleSend}>發送訊息</Button>
                </List>
            </Paper >
        </>
    );
}
const PDF = () => {
    const pdfRef = useRef(null);

    const handleDownload = () => {
        const content = pdfRef.current;

        const doc = new jsPDF();
        doc.html(content, {
            callback: function (doc) {
                doc.save('sample.pdf');
            }
        });
    };

    return (
        <div>
            <header ref={pdfRef}>
                <section></section>
                <section></section>
            </header>
            <footer>
                <button onClick={handleDownload}>Download</button>
            </footer>
        </div>
    );
}
export default PDF;